"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var requestAnimationFrame = require('raf');
var scheduler_1 = require("./scheduler");
var delay_1 = require("./delay");
var debounce_1 = require("./debounce");
var periodic_1 = require("./periodic");
var throttle_1 = require("./throttle");
var animation_frames_1 = require("./animation-frames");
var throttle_animation_1 = require("./throttle-animation");
var run_virtually_1 = require("./run-virtually");
function popAll(array) {
    var poppedItems = [];
    while (array.length > 0) {
        poppedItems.push(array.pop());
    }
    return poppedItems;
}
function runRealtime(scheduler, frameCallbacks, currentTime, setTime) {
    var paused = false;
    var pause = function () { return paused = true; };
    var resume = function (time) {
        setTime(time);
        paused = false;
    };
    function processEvent(eventTime) {
        if (paused) {
            requestAnimationFrame(processEvent);
            return;
        }
        var time = eventTime;
        setTime(time);
        var currentCallbacks = popAll(frameCallbacks);
        currentCallbacks.forEach(function (callback) { return callback(time); });
        if (scheduler.isEmpty()) {
            requestAnimationFrame(processEvent);
            return;
        }
        var nextEventTime = scheduler.peek().time;
        while (nextEventTime < time) {
            var eventToProcess = scheduler.shiftNextEntry();
            if (!eventToProcess.cancelled) {
                if (eventToProcess.f) {
                    eventToProcess.f(eventToProcess, time, scheduler.add, currentTime);
                }
                if (eventToProcess.type === 'next') {
                    eventToProcess.stream.shamefullySendNext(eventToProcess.value);
                }
                if (eventToProcess.type === 'complete') {
                    eventToProcess.stream.shamefullySendComplete();
                }
            }
            nextEventTime = (scheduler.peek() && scheduler.peek().time) || Infinity;
        }
        requestAnimationFrame(processEvent);
    }
    requestAnimationFrame(processEvent);
    return { pause: pause, resume: resume };
}
function timeDriver(_, streamAdapter) {
    var time = 0;
    var frameCallbacks = [];
    var scheduler = scheduler_1.makeScheduler();
    function currentTime() {
        return time;
    }
    function setTime(newTime) {
        time = newTime;
    }
    function addFrameCallback(callback) {
        frameCallbacks.push(callback);
    }
    // TODO - cancel requestAnimationFrame on dispose
    var _a = runRealtime(scheduler, frameCallbacks, currentTime, setTime), pause = _a.pause, resume = _a.resume;
    var timeSource = {
        animationFrames: animation_frames_1.makeAnimationFrames(addFrameCallback, currentTime),
        delay: delay_1.makeDelay(scheduler.add, currentTime),
        debounce: debounce_1.makeDebounce(scheduler.add, currentTime),
        periodic: periodic_1.makePeriodic(scheduler.add, currentTime),
        throttle: throttle_1.makeThrottle(scheduler.add, currentTime),
        throttleAnimation: throttle_animation_1.makeThrottleAnimation(function () { return timeSource; }, scheduler.add, currentTime),
        _time: currentTime,
        _scheduler: scheduler.add,
        _pause: pause,
        _resume: resume,
        _runVirtually: function (done, timeToRunTo) {
            // TODO - frameCallbacks?
            run_virtually_1.runVirtually(scheduler, done, currentTime, setTime, timeToRunTo);
        }
    };
    return timeSource;
}
exports.timeDriver = timeDriver;



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/@cycle/time/dist/time-driver.js
// module id = ../../../node_modules/@cycle/time/dist/time-driver.js
// module chunks = 1